import { Check } from 'lucide-react';
import { useId } from 'react';
import { USER_COLOR_LABELS, USER_COLORS, type UserColor } from '@kominiarz/shared';
import styles from './form.module.css';

interface ColorPickerProps {
  legend: string;
  value: UserColor;
  onChange: (color: UserColor) => void;
  /** Colours already used by other people, marked so the manager can avoid duplicates. */
  taken?: ReadonlySet<UserColor>;
}

export function ColorPicker({ legend, value, onChange, taken }: ColorPickerProps) {
  const name = useId();
  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.label}>{legend}</legend>
      <div className={styles.swatches}>
        {USER_COLORS.map((color) => {
          const selected = color === value;
          return (
            <label key={color} className={styles.swatch} title={USER_COLOR_LABELS[color]}>
              <input
                type="radio"
                name={name}
                value={color}
                checked={selected}
                onChange={() => onChange(color)}
                className="visually-hidden"
              />
              <span
                className={selected ? `${styles.swatchDot} ${styles.swatchSelected}` : styles.swatchDot}
                style={{ background: `var(--user-${color})`, color: `var(--user-${color}-ink)` }}
                aria-hidden="true"
              >
                {selected && <Check />}
              </span>
              <span className={styles.swatchLabel}>
                {USER_COLOR_LABELS[color]}
                {taken?.has(color) && !selected ? <span className={styles.swatchTaken}> (zajęty)</span> : null}
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
